export default __webpack_public_path__ + "static/media/ttgo_device.bcdfd9c2.jpg";